import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { TemplateDocument, TemplateDocumentSequenceDto, TemplateDocumentUpdateDto } from '../models/template.models';
@Injectable({
  providedIn: 'root'
})
export class TemplateDocumentService {
  #apiCalling = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  openDocReviewModel: BehaviorSubject<TemplateDocument | null> = new BehaviorSubject<TemplateDocument | null>(null);

  openReplaceModel: BehaviorSubject<TemplateDocument | null> = new BehaviorSubject<TemplateDocument | null>(null);

  saveTemplateDocument(template: any) {
    return this.#apiCalling.postData(
      `${this.baseUrl}/document-templates`,
      { showLoader: true, showMessage: true, message: 'Template document created successfully' },
      template
    );
  }

  updateTemplateDocument(templateId: string, template: TemplateDocumentUpdateDto) {
    return this.#apiCalling.putData(`${this.baseUrl}/document-templates/${templateId}/replace`, template, {
      showLoader: true,
      showMessage: true,
      message: 'Template document updated successfully'
    });
  }

  readTemplateDocuments(): Observable<TemplateDocument[]> {
    return this.#apiCalling.getData<TemplateDocument[]>(`${this.baseUrl}/document-templates/all`, {
      showLoader: true,
      showMessage: false
    });
  }

  readTemplateVariables(tempVariableId: string) {
    return this.#apiCalling.getData(`${this.baseUrl}/document-templates/variables/${tempVariableId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  readTemplateDocument(templateId: string): Observable<TemplateDocument> {
    return this.#apiCalling.getData<TemplateDocument>(`${this.baseUrl}/document-templates/${templateId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  fillTemplateDocument(templateId: string) {
    return this.#apiCalling.getData(`${this.baseUrl}/document-templates/filled/${templateId}`, {
      showLoader: true,
      showMessage: false
    });
  }

  toggleStatus(templateId: string | null) {
    return this.#apiCalling.patchData(
      `${this.baseUrl}/document-templates/${templateId}/toggle-status`,
      {},
      { showLoader: true, showMessage: true }
    );
  }

  isMasterTemplatePreviewRoute(url: string) {
    return url.includes('master-templates');
  }

  isProjectTemplatePreviewRoute(url: string) {
    return url.includes('projects');
  }

  reorderTemplateDocuments(templateDocument: TemplateDocumentSequenceDto) {
    return this.#apiCalling.patchData(
      `${this.baseUrl}/document-templates/${templateDocument.id}/sequence/${templateDocument.sequence}`,
      {},
      { showLoader: true, showMessage: true, message: 'Template document reordered successfully' }
    );
  }

  // toggleTemplate(templateId: string) {
  //   return this.#apiCalling.patchData(
  //     `${this.baseUrl}/document-templates/${templateId}/toggle-position-lock`,
  //     {},
  //     { showLoader: true, showMessage: false }
  //   );
  // }
}
